import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const CholesterolLogPage = lazy(() => import("./CholesterolLogPage"));

const CholesterolLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <CholesterolLogPage />
    </Suspense>
  );
};

export default CholesterolLogPageLazy;
